
import styled from "styled-components";
import theme from "./../../styles/theme"


export const TitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 60px;
`;

export const Title = styled.h2`
  font-family: ${theme.fonts.montSerrat};
  color: ${theme.colors.white};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  padding-bottom: 10px;
  text-transform: uppercase;
`;

export const Breakline = styled.hr`
  width: 2%;
  background:  ${theme.colors.landingTheme};
  border: 2px solid  ${theme.colors.landingTheme};
  @media (max-width:  ${theme.breakpoints.medium}) {
    width: 10%;
  }
`;

export const Subtitle = styled.h3`
  font-family: ${theme.fonts.montSerrat};
  color: ${theme.colors.white};
  font-style: normal;
  font-weight: ${theme.fontWeights.bold} !important;
  font-size: ${theme.fontSizes.xxLarge};
  line-height: 44px;
`;
